import styled, { css } from 'styled-components';

export const boxLinkStyles = css`
    && {
        // this ensures higher specificity than the BoxLinkContainer rule for links
        position: static;
        z-index: 1;
    }
    &::before {
        content: '';
        position: absolute;
        inset: 0;
        overflow: hidden;
        white-space: nowrap;
        outline: 0;
        z-index: 1;

        // fix for windows high contrast mode making all backgrounds solid black
        opacity: 0;
        background: rgba(0, 0, 0, 0);
    }
    &:focus-visible {
        display: block;
    }
`;

/**
 * A link that expands its click area to fill the nearest BoxLinkContainer.
 */
export const BoxLink = styled.a`
    ${boxLinkStyles};
`;

export const BoxLinkContainer = styled.div`
    position: relative;
    // links and buttons should be elevated above the box link
    a,
    button,
    time[title] {
        z-index: 2;
        position: relative;
    }
`;
